import moment from "moment";

/**
 * Находит количество секунд до текущей даты
 */
export default date => {
  return date ? moment(date).diff(moment(), "seconds") : -1;
};
